import { useCallback, useEffect, useMemo } from "react";
import styles from "./index.module.less";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useUser } from "@/utils/UserContext";
import { editUser } from "@/services/user";
import { checkDict, addDictItem } from "@/services/history";
import { provinceAndCityData } from "@/utils/areaDataUtil";

import {
  InputField,
  SelectField,
  ButtonField,
  Iconsvg,
  Combobox,
  ComboboxSuggestion,
} from "@wk/components-react16";
import {
  getKsDict,
  getDictIdByCode,
  getDictListById,
} from "@/services/history";
import { TreeSelect } from "antd";
import { cloneDeep } from "lodash-es";
import ModalConfirm from "../modal";
import AddYyModal from "../modal/addYy";

const provinceList = cloneDeep(provinceAndCityData);
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const PlayerDetail = () => {
  const navigate = useNavigate();
  const { user, set } = useUser();
  const [userInfo, setUserInfo] = useState();
  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);
  const [yyList, setYyList] = useState([]);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const [isSaveConfirm, setIsSaveConfirm] = useState(false);

  const [nameStatus, setNameStatus] = useState("none");
  const [isValueError, setIsValueError] = useState(false);

  const nameErrorText = useMemo(() => {
    if (nameStatus === "none") {
      return [];
    }
    if (!userInfo?.userName) {
      return [{ label: "请输入选手姓名", labelId: "1" }];
    }

    if (userInfo?.userName.length < 2) {
      return [{ label: "请输入至少2个字符", labelId: "2" }];
    }

    return [];
  }, [nameStatus, userInfo?.userName]);

  const [emailStatus, setEmailStatus] = useState("none");

  const emailErrorText = useMemo(() => {
    if (emailStatus === "none") {
      return [];
    }

    if (!userInfo?.email) {
      return [{ label: "请输入邮箱", labelId: "1" }];
    }

    if (userInfo?.email.length < 6) {
      return [{ label: "请输入至少6个字符", labelId: "2" }];
    }

    if (!emailRegex.test(userInfo?.email)) {
      return [{ label: "请输入正确的邮箱地址", labelId: "3" }];
    }

    return [];
  }, [emailStatus, userInfo?.email]);

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };
  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const getYyList = async (value) => {
    const zcList = await getCaseTypeDict("yy");
    setYyList(zcList);
    if (value) {
      let itemFind = zcList.find((item) => {
        return item?.itemValue === value;
      });
      if (itemFind) {
        // setYyComboboxValue(itemFind);
        setUserInfo((prev) => {
          return {
            ...prev,
            hospital: itemFind?.id,
          };
        });
      }
    }
  };

  const municipalityList = useMemo(() => {
    let itemFind = provinceList.find((item) => {
      return userInfo?.shengfen === item.label;
    });
    if (itemFind) {
      return itemFind.children;
    }
    return [];
  }, [userInfo?.shengfen]);

  const save = async (isCancel = false) => {
    if (!userInfo?.userName || userInfo?.userName.length < 2) {
      setNameStatus("error");
      return;
    }

    if (
      !userInfo?.email ||
      userInfo?.email.length < 6 ||
      !emailRegex.test(userInfo?.email)
    ) {
      setEmailStatus("error");
      return;
    }

    const value = cloneDeep(userInfo);
    value?.keshi ? (value.keshi = value?.keshi.join()) : (value.keshi = "");
    if (!value?.id) return;
    setIsSaveLoading(true);
    try {
      const res = await editUser(value);
    } catch (error) {
      setIsSaveLoading(false);
      setIsSaveConfirm(false);
      set(value);
      if (isCancel) {
        setIsSaveOpen(false);
        navigate("/player");
      }
    }
    setIsSaveConfirm(false);
    setIsSaveLoading(false);
    set(value);
    if (isCancel) {
      setIsSaveOpen(false);
      navigate("/player");
    }
  };

  const [isAddYyOpen, setIsAddYyOpen] = useState(false);
  const [isAddYyLoading, setIsAddYyLoading] = useState(false);
  const [isYyDropdownOpen, setIsYyDropdownOpen] = useState(false);
  const [yyComboboxValue, setYyComboboxValue] = useState({});
  const [yyComboboxInputValue, setYyComboboxInputValue] = useState("");

  const getFilteredOptions = useCallback(() => {
    const value = cloneDeep(yyComboboxInputValue);

    if (yyComboboxValue?.itemText === value) {
      return yyList;
    }

    const filteredOptions = yyList.filter((item) => {
      return item?.itemText.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });

    if (filteredOptions.length === 0) {
      return [{ itemText: `+ 添加机构 ${value}`, id: "create" }];
    }

    return filteredOptions;
  }, [yyComboboxInputValue, yyComboboxValue, yyList]);

  const onClear = () => {
    setYyComboboxInputValue("");
    // setYyComboboxValue({});
    // setUserInfo({ ...userInfo, hospital: "" });
  };

  const onInputClick = () => {
    setIsYyDropdownOpen(true);
  };

  const onComboboxValueChange = (e) => {
    setIsYyDropdownOpen(false);

    if (e?.id !== "create") {
      setYyComboboxInputValue(e?.itemText);
      setYyComboboxValue(e);
      setUserInfo({ ...userInfo, hospital: e?.id });
    } else {
      setIsAddYyOpen(true);
    }
  };

  const onKey = (e) => {
    const { value } = e.target;
    setYyComboboxInputValue(value);
    if (value !== "") {
      setIsYyDropdownOpen(true);
    }
  };

  const addYy = async (value, callBack) => {
    setIsAddYyLoading(true);

    try {
      const res = await getDictIdByCode({ code: "yy" });
      if (!res?.success || !res?.result?.records?.length) {
        setIsAddYyLoading(false);
        return;
      }

      const dictId = res?.result?.records[0]?.id;
      // const checkRes = await checkDict({ dictId, itemValue: value.value });
      // if (checkRes?.code !== 200) {
      //   setIsAddYyLoading(false);
      //   setIsValueError(true);
      //   return;
      // }

      const resAdd = await addDictItem({
        dictId,
        itemText: value.name,
        itemValue: value.value,
      });
      if (resAdd?.code === 200) {
        await getYyList(value.value);
        setIsAddYyOpen(false);
        callBack();
      }
    } catch (error) {
      setIsAddYyLoading(false);
    }

    setIsAddYyLoading(false);
  };

  useEffect(() => {
    const value = cloneDeep(user);
    value?.keshi ? (value.keshi = value?.keshi.split(",")) : (value.keshi = []);
    setUserInfo(value);
  }, [user]);

  useEffect(() => {
    const value = cloneDeep(userInfo);
    let itemFind = yyList.find((item) => {
      return item?.id === value?.hospital;
    });

    if (itemFind) {
      setYyComboboxValue(itemFind);
      setYyComboboxInputValue(itemFind?.itemText);
    }
  }, [userInfo, yyList]);

  useEffect(() => {
    getKsDict().then((res) => {
      setKsList(res.result || []);
    });
    getZcList();
    getYyList();
  }, []);

  return (
    <div className={styles["player-detail"]}>
      <div className="player-info">
        <div className="title">选手个人信息</div>
        <div className="info">
          <div className="left">
            <InputField
              label="选手姓名"
              labelFor="input-id-1-1"
              indicator="required"
              status={nameStatus}
              errors={nameErrorText}
            >
              <input
                type="text"
                id="input-id-1-1"
                name="input-1-1"
                placeholder="请输入选手姓名"
                required
                value={userInfo?.userName}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, userName: e.target.value });
                  if (!e.target.value || e.target.value.length < 2) {
                    setNameStatus("error");
                    return;
                  }

                  setNameStatus("none");
                }}
                maxLength={16}
                minLength={2}
              />
            </InputField>

            <SelectField label="所在省" labelFor="select-id-3-1">
              <select
                id="select-id-3-1"
                name="story3-2"
                value={userInfo?.shengfen || ""}
                onChange={(e) => {
                  setUserInfo({
                    ...userInfo,
                    shengfen: e.target.value,
                    chengshi: "",
                  });
                }}
              >
                <option disabled hidden value={""}>
                  请选择所在省
                </option>

                {provinceList?.map((item) => {
                  return (
                    <option key={item.label} value={item.label}>
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </SelectField>

            {/* <SelectField label="机构" labelFor="select-id-2-1">
              <select
                id="select-id-2-1"
                name="story1-2"
                value={userInfo?.hospital || ""}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, hospital: e.target.value });
                }}
              >
                <option disabled hidden value={""}>
                  请选择机构
                </option>
                {yyList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.itemText}
                    </option>
                  );
                })}
              </select>
            </SelectField> */}

            <Combobox
              isOpen={isYyDropdownOpen}
              hasClearButton={isYyDropdownOpen && yyComboboxInputValue}
              onDropdownUserRequest={(event) => {
                setIsYyDropdownOpen(event);
                setYyComboboxInputValue(yyComboboxValue.itemText);
              }}
              onClearUserRequest={onClear}
              label="机构"
            >
              <input
                placeholder="请选择机构"
                value={yyComboboxInputValue}
                onClick={onInputClick}
                onInput={(event) => onKey(event)}
                slot="comboboxInput"
                maxLength={20}
              />
              {Object.values(getFilteredOptions()).map((item, idx) => {
                return (
                  <React.Fragment key={item.id}>
                    <ComboboxSuggestion
                      isSelected={item.id === yyComboboxValue.id}
                      onItemClick={() => onComboboxValueChange(item)}
                      slot="comboboxSuggestion"
                    >
                      {item.itemText}
                    </ComboboxSuggestion>
                  </React.Fragment>
                );
              })}
            </Combobox>

            <InputField
              label="电子邮箱"
              labelFor="input-id-1-2"
              indicator="required"
              status={emailStatus}
              errors={emailErrorText}
            >
              <input
                type="text"
                id="input-id-1-2"
                name="input-1-2"
                placeholder="请输入电子邮箱"
                required
                value={userInfo?.email}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, email: e.target.value });
                  if (
                    !e.target.value ||
                    e.target.value.length < 6 ||
                    !emailRegex.test(userInfo?.email)
                  ) {
                    setEmailStatus("error");
                    return;
                  }
                  setEmailStatus("none");
                }}
                maxLength={100}
                minLength={6}
              />
            </InputField>
          </div>

          <div className="right">
            <InputField
              label="手机号码"
              labelFor="input-id-2-1"
              indicator="required"
            >
              <input
                type="text"
                id="input-id-2-1"
                name="input-2-1"
                placeholder="请输入手机号码"
                required
                value={userInfo?.phone}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, phone: e.target.value });
                }}
                readOnly
              />
            </InputField>

            <SelectField label="所在市" labelFor="select-id-2-1">
              <select
                id="select-id-2-1"
                name="story2-1"
                value={userInfo?.chengshi || ""}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, chengshi: e.target.value });
                }}
              >
                <option disabled hidden value={""}>
                  请选择所在市
                </option>
                {municipalityList?.map((item) => {
                  return (
                    <option key={item.label} value={item.label}>
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </SelectField>

            <SelectField label="职称" labelFor="select-id-1-1">
              <select
                id="select-id-1-1"
                name="story1-1"
                value={userInfo?.zhicheng || ""}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, zhicheng: e.target.value });
                }}
              >
                <option disabled hidden value={""}>
                  请选择职称或职务
                </option>
                {zcList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.itemText}
                    </option>
                  );
                })}
              </select>
            </SelectField>

            <div className="department">
              <div className="header">科室</div>
              <TreeSelect
                style={{ width: "100%" }}
                value={userInfo?.keshi}
                styles={{
                  popup: { root: { maxHeight: 400, overflow: "auto" } },
                }}
                treeData={ksList}
                placeholder="请选择科室"
                treeDefaultExpandAll
                onChange={(value) => {
                  setUserInfo({ ...userInfo, keshi: value });
                }}
                multiple
                maxCount={5}
                size="large"
                showSearch
                treeNodeFilterProp="title"
                fieldNames={{
                  value: "key",
                }}
              />
            </div>
          </div>
        </div>
        <div className="btns">
          <ButtonField mode={"ghost"}>
            <button
              type="button"
              onClick={() => {
                // const value = cloneDeep(user);
                // value?.keshi
                //   ? (value.keshi = value?.keshi.split(","))
                //   : (value.keshi = []);
                // setUserInfo(value);
                // setEmailStatus("none");
                // setNameStatus("none");
                setIsSaveOpen(true);
              }}
              disabled={isSaveLoading || !userInfo?.id}
            >
              取消
            </button>
          </ButtonField>

          <ButtonField>
            <button
              type="button"
              onClick={() => {
                if (!userInfo?.userName || userInfo?.userName.length < 2) {
                  setNameStatus("error");
                  return;
                }

                if (
                  !userInfo?.email ||
                  userInfo?.email.length < 6 ||
                  !emailRegex.test(userInfo?.email)
                ) {
                  setEmailStatus("error");
                  return;
                }

                setIsSaveConfirm(true);
              }}
              disabled={isSaveLoading || !userInfo?.id}
            >
              保存修改
              {isSaveLoading && <Iconsvg name="spinner-alt" isSpin></Iconsvg>}
            </button>
          </ButtonField>
        </div>
      </div>

      <ModalConfirm
        isOpen={isSaveOpen}
        onClose={() => {
          setIsSaveOpen(false);
          navigate("/player");
        }}
        children={
          <div className="modal-body-text">是否需要保存已填写信息?</div>
        }
        title={"操作确认"}
        onConfirm={() => save(true)}
        isConfirmLoading={isSaveLoading}
        okText="确定"
      />

      <ModalConfirm
        isOpen={isSaveConfirm}
        onClose={() => {
          setIsSaveConfirm(false);
        }}
        children={<div className="modal-body-text">是否保存修改?</div>}
        title={"操作确认"}
        onConfirm={() => save()}
        isConfirmLoading={isSaveLoading}
        okText="确定"
      />

      <AddYyModal
        nameValue={yyComboboxInputValue}
        isOpen={isAddYyOpen}
        onClose={() => {
          setIsAddYyOpen(false);
          setIsAddYyLoading(false);
        }}
        title="添加机构"
        onConfirm={(value, callBack) => {
          addYy(value, callBack);
        }}
        isConfirmLoading={isAddYyLoading}
        height="auto"
        okText="提交"
      />

      <ModalConfirm
        isOpen={isValueError}
        onClose={() => {
          setIsValueError(false);
        }}
        children={
          <div className="modal-body-text">数据值不可用，系统中已存在！</div>
        }
        title={"操作确认"}
        onConfirm={() => {
          setIsValueError(false);
        }}
        okText="确定"
      />
    </div>
  );
};
export default PlayerDetail;
